import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {AuthenticationConfigurationService} from '@modules/authentication/core/config/authentication-configuration.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {defaultURL} from '../../../../../settings/humanum';

@Component({
    selector: 'app-sso-login',
    imports: [
        TranslateModule,
        MatButtonModule
    ],
    templateUrl: './sso-login.component.html',
    styleUrl: './sso-login.component.scss'
})
export class SsoLoginComponent {

    private translate = inject(TranslateService)
    private config = inject(AuthenticationConfigurationService);

    public onLoginSSOClick(): void {
        window.location.href = this.config.settings.urlSSO[this.translate.currentLang] + defaultURL + 'login';
    }
}
